import { useContent } from "../context/ContentContext";
import { resolveAsset } from "../lib/api";

export const Trayectoria = () => {
  const { content } = useContent();
  return (
  <section id="trayectoria" data-testid="trayectoria-section" className="section-anchor bg-[#050F30]/45 py-24 lg:py-32">
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#8AB0FF] mb-4 reveal">Trayectoria</p>
      <h2 className="font-serif-display text-3xl sm:text-4xl font-semibold text-white mb-16 reveal">
        Línea de tiempo
      </h2>

      <div className="relative pl-8 sm:pl-10">
        <div className="timeline-line absolute left-[7px] sm:left-[9px] top-1 bottom-1 w-px" aria-hidden="true" />
        <div className="space-y-12">
          {(content.timeline || []).map((item, i) => (
            <div key={i} data-testid={`timeline-item-${i}`} className="relative reveal">
              <span
                className="absolute -left-8 sm:-left-10 top-1.5 w-[15px] h-[15px] sm:w-[19px] sm:h-[19px] rounded-full border-2 border-[#0057FF] bg-[#071D4D]"
                aria-hidden="true"
              />
              <p className="text-xs uppercase tracking-[0.2em] text-[#8AB0FF] mb-1">{item.period}</p>
              <h3 className="font-serif-display text-xl sm:text-2xl font-medium text-white">{item.title}</h3>
              <p className="text-neutral-300 mt-1">{item.description}</p>
              {item.logo && (
                <img
                  data-testid={`timeline-logo-${i}`}
                  src={resolveAsset(item.logo)}
                  alt={item.logoAlt || item.title}
                  className="h-14 w-auto rounded-md mt-3 border border-[#C0C7D1]/50"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
  );
};
